import React, {createContext, useContext} from 'react';

export interface AskAIScope {
  collection: string;
  tabId: string;
  year: string;
}

const AskAIScopeContext = createContext<AskAIScope | null>(null);

export const AskAIScopeProvider: React.FC<
  React.PropsWithChildren<{value: AskAIScope}>
> = ({value, children}) => {
  return (
    <AskAIScopeContext.Provider value={value}>
      {children}
    </AskAIScopeContext.Provider>
  );
};

export const useAskAIScope = (): AskAIScope | null => {
  return useContext(AskAIScopeContext);
};
